
// Ads
let ads = require('./adv/ads.js');
ads.init(document.body);

// AnotherSlideViewed
let anotherSlideViewed = require('./adv/anotherSlideViewed.js');
anotherSlideViewed.init(document.body);